import styled from 'styled-components';

export const TablesContainer = styled.div`
  max-width: 1236px;
  min-width: 1236px;

  overflow-x: hidden;
`;
export const FloatElement = styled.div`
  min-width: 610px;
  box-sizing: border-box;
  max-height: 310px;
  border: 1.5px solid rgba(229, 232, 237, 1);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(253, 253, 253, 1) 0%, rgba(254, 254, 254, 1) 100%);
  float: left;
  &:nth-child(2n + 0) {
    float: right;
  }
  margin: 8px 0;
  padding-bottom: 10px;
`;
export const TablesWrapper = styled.div`
  overflow-x: auto;
  margin: 10px;
  padding-bottom: 50px;
  width: auto;
`;
export const MainText = styled.div`
  color: rgba(66, 72, 84, 1);
  font-family: 'Proxima Nova';
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.21px;
  line-height: 17px;
  text-align: center;
  margin-right: 5px;
`;
export const ScorecardTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead {
    tr {
      th {
        box-sizing: border-box;
        height: 39px;
        background-color: rgba(229, 231, 237, 1);
        color: rgba(66, 72, 84, 1);
        font-family: 'Proxima Nova';
        font-size: 12px;
        font-weight: 600;
        letter-spacing: -0.15px;
        line-height: 17px;
        position: sticky;
        top: 0px;
      }
    }
  }
  tbody {
    tr {
      td {
        border-bottom: 1px solid rgba(243, 244, 247, 1);
        background: white;
        height: 17px;
        color: rgba(66, 72, 84, 1);
        font-family: 'Proxima Nova';
        font-size: 12px;
        letter-spacing: -0.15px;
        line-height: 17px;
        text-align: center;
        padding: 5px 0px;
      }
      td:first-of-type {
        padding-left: 35px;
      }
    }
    tr:last-child {
      td {
        border-bottom: 0px solid rgba(243, 244, 247, 1);
      }
    }
  }
`;
export const UpperHeader = styled.div`
  display: flex;
  justify-content: center;
  span {
    margin-left: 5px;
    color: rgba(93, 110, 129, 1);
    font-family: 'Proxima Nova';
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.16px;
    line-height: 17px;
    text-align: center;
  }
`;
export const SubText = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 12px;
  letter-spacing: -0.15px;
  line-height: 17px;
  text-align: center;
`;

export const Header = styled.div`
  display: flex;
  height: 66px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
export const Body = styled.div`
  max-height: 234px;
  overflow-x: auto;
`;
